var cities = [
"MEDELLIN",
"ABEJORRAL",
"ABRIAQUI",
"ALEJANDRIA",
"AMAGA",
"AMALFI",
"ANDES",
"ANGELOPOLIS",
"ANGOSTURA",
"ANORI",
"SANTAFE DE ANTIOQUIA",
"ANZA",
"APARTADO",
"ARBOLETES",
"ARGELIA",
"MANTEQUILLA ARMENIA",
"BARBOSA",
"BELMIRA",
"BELLO",
"BETANIA",
"BETULIA",
"CIUDAD BOLIVAR",
"BRICENO",
"BURITICA",
"CACERES",
"CAICEDO",
"CALDAS",
"CAMPAMENTO",
"CANASGORDAS",
"CARACOLI",
"CARAMANTA",
"CAREPA",
"EL CARMEN DE VIBORAL",
"CAROLINA",
"CAUCASIA",
"CHIGORODO",
"CISNEROS",
"COCORNA",
"CONCEPCION",
"CONCORDIA",
"COPACABANA",
"DABEIBA",
"DON MATIAS",
"EBEJICO",
"EL BAGRE",
"ENTRERRIOS",
"ENVIGADO",
"FREDONIA",
"FRONTINO",
"GIRALDO",
"GIRARDOTA",
"GOMEZ PLATA",
"GRANADA",
"GUADALUPE",
"GUARNE",
"GUATAPE",
"HELICONIA",
"HISPANIA",
"ITAGUI",
"ITUANGO",
"JARDIN",
"JERICO",
"LA CEJA",
"LA ESTRELLA",
"LA PINTADA",
"LA UNION",
"LIBORINA",
"MACEO",
"MARINILLA",
"MONTEBELLO",
"MURINDO",
"MUTATA",
"NARINO",
"NECOCLI",
"NECHI",
"OLAYA",
"PENOL",
"PEQUE",
"PUEBLORRICO",
"PUERTO BERRIO",
"PUERTO NARE",
"PUERTO TRIUNFO",
"REMEDIOS",
"RETIRO",
"RIONEGRO",
"SABANALARGA",
"SABANETA",
"SALGAR",
"SAN ANDRES",
"SAN CARLOS",
"SAN FRANCISCO",
"SAN JERONIMO",
"SAN JOSE DE LA MONTANA",
"SAN JUAN DE URABA",
"SAN LUIS",
"SAN PEDRO",
"SAN PEDRO DE URABA",
"SAN RAFAEL",
"SAN ROQUE",
"SAN VICENTE",
"SANTA BARBARA",
"SANTA ROSA DE OSOS",
"SANTO DOMINGO",
"EL SANTUARIO",
"SEGOVIA",
"SONSON",
"SOPETRAN",
"TAMESIS",
"TARAZA",
"TARSO",
"TITIRIBI",
"TOLEDO",
"TURBO",
"URAMITA",
"URRAO",
"VALDIVIA",
"VALPARAISO",
"VEGACHI",
"VENECIA",
"VIGIA DEL FUERTE",
"YALI",
"YARUMAL",
"YOLOMBO",
"YONDO",
"ZARAGOZA",
"BARRANQUILLA",
"BARANOA",
"CAMPO DE LA CRUZ",
"CANDELARIA",
"GALAPA",
"JUAN DE ACOSTA",
"LURUACO",
"MALAMBO",
"MANATI",
"Palmar de Varela",
"PIOJO",
"POLONUEVO",
"PUERTO COLOMBIA",
"REPELON",
"SABANAGRANDE",
"SABANALARGA",
"SANTA LUCIA",
"SANTO TOMAS",
"SOLEDAD",
"SUAN",
"USIACURI",
"BOGOTA",
"CARTAGENA",
"ACHI",
"ALTOS DEL ROSARIO",
"ARJONA",
"ARROYOHONDO",
"BARRANCO DE LOBA",
"CALAMAR",
"CANTAGALLO",
"CICUCO",
"CORDOBA",
"CLEMENCIA",
"EL CARMEN DE BOLIVAR",
"EL GUAMO",
"EL PENON",
"HATILLO DE LOBA",
"MAGANGUE",
"MAHATES",
"MARGARITA",
"MARIA LA BAJA",
"MONTECRISTO",
"MOMPOS",
"MORALES",
"NOROSI",
"PINILLOS",
"REGIDOR",
"RIO VIEJO",
"SAN CRISTOBAL",
"SAN ESTANISLAO",
"SAN FERNANDO",
"SAN JACINTO",
"SAN JUAN NEPOMUCENO",
"SAN MARTIN DE LOBA",
"SAN PABLO",
"SANTA CATALINA",
"SANTA ROSA",
"SANTA ROSA DEL SUR",
"SIMITI",
"SOPLAVIENTO",
"TALAIGUA NUEVO",
"TIQUISIO",
"TURBACO",
"TURBANA",
"VILLANUEVA",
"ZAMBRANO",
"ISLA BARU",
"TUNJA",
"ALMEIDA",
"AQUITANIA",
"ARCABUCO",
"BELEN",
"BERBEO",
"BETEITIVA",
"BOAVITA",
"BOYACA",
"BRICENO",
"BUENAVISTA",
"BUSBANZA",
"CALDAS",
"CAMPOHERMOSO",
"CERINZA",
"CHINAVITA",
"CHIQUINQUIRA",
"CHISCAS",
"CHITA",
"CHITARAQUE",
"CHIVATA",
"CIENEGA",
"COMBITA",
"COPER",
"CORRALES",
"COVARACHIA",
"CUBARA",
"CUCAITA",
"CUITIVA",
"CHIQUIZA",
"CHIVOR",
"DUITAMA",
"EL COCUY",
"EL ESPINO",
"FIRAVITOBA",
"FLORESTA",
"GACHANTIVA",
"GAMEZA",
"GARAGOA",
"GUACAMAYAS",
"GUATEQUE",
"GUAYATA",
"GUICAN",
"IZA",
"JENESANO",
"JERICO",
"LABRANZAGRANDE",
"LA CAPILLA",
"LA VICTORIA",
"LA UVITA",
"VILLA DE LEYVA",
"MACANAL",
"MARIPI",
"MIRAFLORES",
"MONGUA",
"MONGUI",
"MONIQUIRA",
"MOTAVITA",
"MUZO",
"NOBSA",
"NUEVO COLON",
"OICATA",
"OTANCHE",
"PACHAVITA",
"PAEZ",
"PAIPA",
"PAJARITO",
"PANQUEBA",
"PAUNA",
"PAYA",
"PAZ DE RIO",
"PESCA",
"PISBA",
"PUERTO BOYACA",
"QUIPAMA",
"RAMIRIQUI",
"RAQUIRA",
"RONDON",
"SABOYA",
"SACHICA",
"SAMACA",
"SAN EDUARDO",
"SAN JOSE DE PARE",
"SAN LUIS DE GACENO",
"SAN MATEO",
"SAN MIGUEL DE SEMA",
"SAN PABLO DE BORBUR",
"SANTANA",
"SANTA MARIA-BOY",
"SANTA ROSA DE VITERBO",
"SANTA SOFIA",
"SATIVANORTE",
"SATIVASUR",
"SIACHOQUE",
"SOATA",
"SOCOTA",
"SOCHA",
"SOGAMOSO",
"SOMONDOCO",
"SORA",
"SOTAQUIRA",
"SORACA",
"SUSACON",
"SUTAMARCHAN",
"SUTATENZA",
"TASCO",
"TENZA",
"TIBANA",
"TIBASOSA",
"TINJACA",
"TIPACOQUE",
"TOCA",
"TOGUI",
"TOPAGA",
"TOTA",
"TURMEQUE",
"TUTA",
"TUTAZA",
"UMBITA",
"VENTAQUEMADA",
"VIRACACHA",
"ZETAQUIRA",
"MANIZALES",
"AGUADAS",
"ANSERMA",
"ARANZAZU",
"BELALCAZAR",
"CHINCHINA",
"FILADELFIA",
"LA DORADA",
"LA MERCED",
"MANZANARES",
"MARMATO",
"MARQUETALIA",
"MARULANDA",
"NEIRA",
"NORCASIA",
"PACORA",
"PALESTINA",
"PENSILVANIA",
"RIOSUCIO",
"RISARALDA",
"SALAMINA",
"SAMANA",
"SAN JOSE",
"SUPIA",
"VICTORIA",
"VILLAMARIA",
"VITERBO",
"FLORENCIA",
"ALBANIA",
"BELEN DE LOS ANDAQUIES",
"CARTAGENA DEL CHAIRA",
"CURILLO",
"EL DONCELLO",
"EL PAUJIL",
"LA MONTANITA",
"MILAN",
"MORELIA",
"PUERTO RICO",
"SAN JOSE DEL FRAGUA",
"SAN VICENTE DEL CAGUAN",
"SOLANO",
"SOLITA",
"VALPARAISO",
"POPAYAN",
"ALMAGUER",
"ARGELIA",
"BALBOA",
"BOLIVAR",
"BUENOS AIRES",
"CAJIBIO",
"CALDONO",
"CALOTO",
"CORINTO",
"EL TAMBO",
"GUACHENE",
"GUAPI",
"INZA",
"JAMBALO",
"LA SIERRA",
"LA VEGA",
"MERCADERES",
"MIRANDA",
"MORALES",
"PADILLA",
"PATIA",
"PIAMONTE",
"PIENDAMO",
"PUERTO TEJADA",
"PURACE",
"ROSAS",
"SAN SEBASTIAN",
"SANTANDER DE QUILICHAO",
"SILVIA",
"SOTARA",
"SUAREZ",
"SUCRE",
"TIMBIO",
"TIMBIQUI",
"TORIBIO",
"TOTORO",
"VILLA RICA",
"VALLEDUPAR",
"AGUACHICA",
"AGUSTIN CODAZZI",
"ASTREA",
"BECERRIL",
"BOSCONIA",
"CHIMICHAGUA",
"CHIRIGUANA",
"CURUMANI",
"EL COPEY",
"EL PASO",
"GAMARRA",
"GONZALEZ",
"LA GLORIA",
"LA JAGUA DE IBIRICO",
"MANAURE",
"PAILITAS",
"PELAYA",
"PUEBLO BELLO",
"RIO DE ORO",
"LA PAZ",
"SAN ALBERTO",
"SAN DIEGO",
"SAN MARTIN",
"TAMALAMEQUE",
"MONTERIA",
"AYAPEL",
"BUENAVISTA",
"CANALETE",
"CERETE",
"CHIMA",
"CHINU",
"CIENAGA DE ORO",
"LA APARTADA",
"LORICA",
"LOS CORDOBAS",
"MOMIL",
"MONTELIBANO",
"MONITOS",
"PLANETA RICA",
"PUEBLO NUEVO",
"PUERTO ESCONDIDO",
"PUERTO LIBERTADOR",
"SAHAGUN",
"SAN ANDRES SOTAVENTO",
"SAN ANTERO",
"SAN BERNARDO DEL VIENTO",
"SAN CARLOS",
"SAN PELAYO",
"TIERRALTA",
"VALENCIA",
"AGUA DE DIOS",
"ALBAN",
"ANAPOIMA",
"ANOLAIMA",
"ARBELAEZ",
"BELTRAN",
"BITUIMA",
"BOJACA",
"CABRERA",
"CACHIPAY",
"CAJICA",
"CAPARRAPI",
"CAQUEZA",
"CARMEN DE CARUPA",
"CHAGUANI",
"CHIA",
"CHIPAQUE",
"CHOACHI",
"CHOCONTA",
"COGUA",
"COTA",
"CUCUNUBA",
"EL COLEGIO",
"EL PENON",
"EL ROSAL",
"FACATATIVA",
"FOMEQUE",
"FOSCA",
"FUNZA",
"FUQUENE",
"FUSAGASUGA",
"GACHALA",
"GACHANCIPA",
"GACHETA",
"GAMA",
"GIRARDOT",
"GRANADA",
"GUACHETA",
"GUADUAS",
"GUASCA",
"GUATAQUI",
"GUATAVITA",
"GUAYABAL DE SIQUIMA",
"GUAYABETAL",
"GUTIERREZ",
"JERUSALEN",
"JUNIN",
"LA CALERA",
"LA MESA",
"LA PALMA",
"LA PENA",
"LA VEGA",
"LENGUAZAQUE",
"MACHETA",
"MADRID",
"MANTA",
"MEDINA",
"MOSQUERA",
"NARINO",
"NEMOCON",
"NILO",
"NIMAIMA",
"NOCAIMA",
"PACHO",
"PAIME",
"PANDI",
"PARATEBUENO",
"PASCA",
"PUERTO SALGAR",
"PULI",
"QUEBRADANEGRA",
"QUETAME",
"QUIPILE",
"APULO",
"RICAURTE",
"SAN ANTONIO DEL TEQUENDAMA",
"SAN BERNARDO",
"SAN CAYETANO",
"SAN FRANCISCO",
"SAN JUAN DE RIO SECO",
"SASAIMA",
"SESQUILE",
"SIBATE",
"SILVANIA",
"SIMIJACA",
"SOACHA",
"SOPO",
"SUBACHOQUE",
"SUESCA",
"SUPATA",
"SUSA",
"SUTATAUSA",
"TABIO",
"TAUSA",
"TENA",
"TENJO",
"TIBACUY",
"TIBIRITA",
"TOCAIMA",
"TOCANCIPA",
"TOPAIPI",
"UBALA",
"UBAQUE",
"UBATE",
"UNE",
"UTICA",
"VERGARA",
"VIANI",
"VILLAGOMEZ",
"VILLAPINZON",
"VILLETA",
"VIOTA",
"YACOPI",
"ZIPACON",
"ZIPAQUIRA",
"QUIBDO",
"ACANDI",
"ALTO BAUDO",
"ATRATO",
"BAGADO",
"BAHIA SOLANO",
"BAJO BAUDO",
"BOJAYA",
"EL CANTON DEL SAN PABLO",
"CONDOTO",
"EL CARMEN DE ATRATO",
"ISTMINA",
"JURADO",
"LLORO",
"MEDIO ATRATO",
"MEDIO BAUDO",
"NOVITA",
"NUQUI",
"RIO QUITO",
"RIOSUCIO",
"SIPI",
"TADO",
"UNGUIA",
"NEIVA",
"ACEVEDO",
"AGRADO",
"AIPE",
"ALGECIRAS",
"BARAYA",
"CAMPOALEGRE",
"COLOMBIA",
"ELIAS",
"GARZON",
"GIGANTE",
"GUADALUPE",
"IQUIRA",
"ISNOS",
"LA ARGENTINA",
"LA PLATA",
"NATAGA",
"OPORAPA",
"PAICOL",
"PALERMO",
"PITAL",
"PITALITO",
"RIVERA",
"SALADOBLANCO",
"SAN AGUSTIN",
"SANTA MARIA",
"SUAZA",
"TARQUI",
"TESALIA",
"TELLO",
"TERUEL",
"TIMANA",
"VILLAVIEJA",
"YAGUARA",
"RIOHACHA",
"ALBANIA",
"BARRANCAS",
"DIBULLA",
"DISTRACCION",
"EL MOLINO",
"FONSECA",
"HATONUEVO",
"LA JAGUA DEL PILAR",
"MAICAO",
"MANAURE",
"SAN JUAN DEL CESAR",
"URIBIA",
"URUMITA",
"VILLANUEVA",
"SANTA MARTA",
"ARACATACA",
"ARIGUANI",
"CERRO SAN ANTONIO",
"CHIBOLO",
"CIENAGA",
"EL BANCO",
"EL PINON",
"FUNDACION",
"GUAMAL",
"PEDRAZA",
"PIJINO DEL CARMEN",
"PIVIJAY",
"PLATO",
"REMOLINO",
"SABANAS DE SAN ANGEL",
"SALAMINA",
"SAN SEBASTIAN DE BUENAVISTA",
"SAN ZENON",
"SANTA ANA",
"SITIONUEVO",
"TENERIFE",
"VILLAVICENCIO",
"ACACIAS",
"BARRANCA DE UPIA",
"CABUYARO",
"CASTILLA LA NUEVA",
"CUMARAL",
"EL CALVARIO",
"EL CASTILLO",
"EL DORADO",
"FUENTE DE ORO",
"GRANADA",
"GUAMAL",
"MAPIRIPAN",
"MESETAS",
"LA MACARENA",
"URIBE",
"LEJANIAS",
"PUERTO CONCORDIA",
"PUERTO GAITAN",
"PUERTO LOPEZ",
"PUERTO LLERAS",
"PUERTO RICO",
"RESTREPO",
"SAN CARLOS DE GUAROA",
"SAN JUAN DE ARAMA",
"SAN JUANITO",
"SAN MARTIN",
"VISTAHERMOSA",
"PASTO",
"ALBAN",
"ALDANA",
"ANCUYA",
"ARBOLEDA",
"BARBACOAS",
"BELEN",
"BUESACO",
"COLON",
"CONSACA",
"CONTADERO",
"CORDOBA",
"CUASPUD",
"CUMBAL",
"CUMBITARA",
"CHACHAGUI",
"EL CHARCO",
"EL PENOL",
"EL ROSARIO",
"EL TABLON DE GOMEZ",
"EL TAMBO",
"FUNES",
"GUACHUCAL",
"GUAITARILLA",
"IMUES",
"IPIALES",
"LA CRUZ",
"LA FLORIDA",
"LA LLANADA",
"LA TOLA",
"LA UNION",
"LEIVA",
"LINARES",
"LOS ANDES",
"MAGUI",
"MALLAMA",
"MOSQUERA",
"NARINO",
"OSPINA",
"POLICARPA",
"POTOSI",
"PROVIDENCIA",
"PUERRES",
"PUPIALES",
"RICAURTE",
"SAMANIEGO",
"SANDONA",
"SAN BERNARDO",
"SAN LORENZO",
"SAN PABLO",
"SAN PEDRO DE CARTAGO",
"SAPUYES",
"TAMINANGO",
"TANGUA",
"TUMACO",
"TUQUERRES",
"YACUANQUER",
"CUCUTA",
"ABREGO",
"ARBOLEDAS",
"BOCHALEMA",
"BUCARASICA",
"CACOTA",
"CACHIRA",
"CHINACOTA",
"CHITAGA",
"CONVENCION",
"CUCUTILLA",
"DURANIA",
"EL CARMEN",
"EL TARRA",
"EL ZULIA",
"GRAMALOTE",
"HACARI",
"HERRAN",
"LABATECA",
"LA PLAYA",
"LOS PATIOS",
"LOURDES",
"MUTISCUA",
"OCANA",
"PAMPLONA",
"PAMPLONITA",
"PUERTO SANTANDER",
"RAGONVALIA",
"SALAZAR",
"SAN CALIXTO",
"SAN CAYETANO",
"SANTIAGO",
"SARDINATA",
"SILOS",
"TEORAMA",
"TIBU",
"TOLEDO",
"VILLA CARO",
"VILLA DEL ROSARIO",
"ARMENIA",
"BUENAVISTA",
"CALARCA",
"CIRCASIA",
"CORDOBA",
"FILANDIA",
"GENOVA",
"LA TEBAIDA",
"MONTENEGRO",
"PIJAO",
"QUIMBAYA",
"SALENTO",
"PEREIRA",
"APIA",
"BALBOA",
"BELEN DE UMBRIA",
"DOSQUEBRADAS",
"GUATICA",
"LA CELIA",
"LA VIRGINIA",
"MARSELLA",
"MISTRATO",
"PUEBLO RICO",
"QUINCHIA",
"SANTA ROSA DE CABAL",
"SANTUARIO",
"BUCARAMANGA",
"AGUADA",
"ALBANIA",
"ARATOCA",
"BARBOSA",
"BARICHARA",
"BARRANCABERMEJA",
"BETULIA",
"BOLIVAR",
"CABRERA",
"CALIFORNIA",
"CAPITANEJO",
"CARCASI",
"CEPITA",
"CERRITO",
"CHARALA",
"CHARTA",
"CIMITARRA",
"CONCEPCION",
"CONFINES",
"CONTRATACION",
"COROMORO",
"CURITI",
"EL CARMEN DE CHUCURI",
"EL GUACAMAYO",
"EL PENON",
"ENCINO",
"FLORIAN",
"FLORIDABLANCA",
"GALAN",
"GAMBITA",
"GIRON",
"GUAPOTA",
"GUAVATA",
"GUEPSA",
"HATO",
"JESUS MARIA",
"JORDAN",
"LA BELLEZA",
"LANDAZURI",
"LEBRIJA",
"LOS SANTOS",
"MACARAVITA",
"MALAGA",
"MATANZA",
"MOGOTES",
"MOLAGAVITA",
"OCAMONTE",
"ONZAGA",
"PALMAR",
"PALMAS DEL SOCORRO",
"PARAMO",
"PIEDECUESTA",
"PINCHOTE",
"PUENTE NACIONAL",
"PUERTO PARRA",
"PUERTO WILCHES",
"RIONEGRO",
"SABANA DE TORRES",
"SAN ANDRES",
"SAN BENITO",
"SAN GIL",
"SAN JOAQUIN",
"SAN JOSE DE MIRANDA",
"SAN MIGUEL",
"SAN VICENTE DE CHUCURI",
"SANTA BARBARA",
"SANTA HELENA DEL OPON",
"SIMACOTA",
"SOCORRO",
"SUAITA",
"SUCRE",
"SURATA",
"TONA",
"VALLE DE SAN JOSE",
"VELEZ",
"VETAS",
"VILLANUEVA",
"ZAPATOCA",
"SINCELEJO",
"COLOSO",
"COROZAL",
"COVENAS",
"CHALAN",
"EL ROBLE",
"GALERAS",
"GUARANDA",
"LOS PALMITOS",
"MAJAGUAL",
"MORROA",
"OVEJAS",
"PALMITO",
"SAMPUES",
"SAN BENITO ABAD",
"SAN JUAN DE BETULIA",
"SAN MARCOS",
"SAN ONOFRE",
"SAN PEDRO",
"SINCE",
"SUCRE",
"SANTIAGO DE TOLU",
"TOLUVIEJO",
"IBAGUE",
"ALPUJARRA",
"ALVARADO",
"AMBALEMA",
"ANZOATEGUI",
"ARMERO",
"ATACO",
"CAJAMARCA",
"CARMEN DE APICALA",
"CASABIANCA",
"CHAPARRAL",
"COYAIMA",
"CUNDAY",
"DOLORES",
"ESPINAL",
"FALAN",
"FLANDES",
"FRESNO",
"GUAMO",
"HERVEO",
"HONDA",
"ICONONZO",
"LERIDA",
"LIBANO",
"MARIQUITA",
"MELGAR",
"MURILLO",
"NATAGAIMA",
"ORTEGA",
"PALOCABILDO",
"PIEDRAS",
"PLANADAS",
"PRADO",
"PURIFICACION",
"RIOBLANCO",
"RONCESVALLES",
"ROVIRA",
"SALDANA",
"SAN ANTONIO",
"SANTA ISABEL",
"VALLE DE SAN JUAN",
"VENADILLO",
"VILLAHERMOSA",
"VILLARRICA",
"CALI",
"ALCALA",
"ANDALUCIA",
"ANSERMANUEVO",
"ARGELIA",
"BOLIVAR",
"BUENAVENTURA",
"BUGA",
"BUGALAGRANDE",
"CAICEDONIA",
"CALIMA",
"CANDELARIA",
"CARTAGO",
"DAGUA",
"EL AGUILA",
"EL CAIRO",
"EL CERRITO",
"EL DOVIO",
"FLORIDA",
"GINEBRA",
"GUACARI",
"JAMUNDI",
"LA CUMBRE",
"LA UNION",
"LA VICTORIA",
"OBANDO",
"PALMIRA",
"PRADERA",
"RESTREPO",
"RIOFRIO",
"ROLDANILLO",
"SAN PEDRO",
"SEVILLA",
"TORO",
"TRUJILLO",
"TULUA",
"ULLOA",
"VERSALLES",
"VIJES",
"YOTOCO",
"YUMBO",
"ZARZAL",
"ARAUCA",
"ARAUQUITA",
"CRAVO NORTE",
"FORTUL",
"PUERTO RONDON",
"SARAVENA",
"TAME",
"YOPAL",
"AGUAZUL",
"CHAMEZA",
"HATO COROZAL",
"LA SALINA",
"MANI",
"MONTERREY",
"NUNCHIA",
"OROCUE",
"PAZ DE ARIPORO",
"PORE",
"RECETOR",
"SABANALARGA",
"SACAMA",
"SAN LUIS DE PALENQUE",
"TAMARA",
"TAURAMENA",
"TRINIDAD",
"VILLANUEVA",
"MOCOA",
"COLON",
"ORITO",
"PUERTO ASIS",
"PUERTO CAICEDO",
"PUERTO GUZMAN",
"PUERTO LEGUIZAMO",
"SIBUNDOY",
"SAN FRANCISCO",
"SAN MIGUEL",
"SANTIAGO",
"VALLE DEL GUAMUEZ",
"VILLAGARZON",
"SAN ANDRES-SAP",
"PROVIDENCIA",
"LETICIA",
"EL ENCANTO",
"LA CHORRERA",
"LA PEDRERA",
"LA VICTORIA",
"MIRITI - PARANA",
"PUERTO ALEGRIA",
"PUERTO ARICA",
"PUERTO NARINO",
"TARAPACA",
"INIRIDA",
"SAN FELIPE",
"PUERTO COLOMBIA",
"CACAHUAL",
"SAN JOSE DEL GUAVIARE",
"EL RETORNO",
"MIRAFLORES",
"MITU",
"CARURU",
"PUERTO CARRENO",
"LA PRIMAVERA",
"SANTA ROSALIA",
"CUMARIBO",
"RIOHACHA",
"ALBANIA-LAG",
"BARRANCAS",
"DIBULLA",
"DISTRACCION",
"EL MOLINO",
"FONSECA",
"HATONUEVO",
"LA JAGUA DEL PILAR",
"MAICAO",
"MANAURE",
"SAN JUAN DEL CESAR",
"URIBIA",
"URUMITA",
"VILLANUEVA-LAG",
"MEDELLIN",
"ABEJORRAL",
"ABRIAQUI",
"ALEJANDRIA",
"AMAGA",
"AMALFI",
"ANDES",
"ANGELOPOLIS",
"ANGOSTURA",
"ANORI",
"SANTAFE DE ANTIOQUIA",
"ANZA",
"APARTADO",
"ARBOLETES",
"ARGELIA",
"MANTEQUILLA ARMENIA",
"BARBOSA",
"BELMIRA",
"BELLO",
"BETANIA",
"BETULIA",
"CIUDAD BOLIVAR",
"BRICENO",
"BURITICA",
"CACERES",
"CAICEDO",
"CALDAS",
"CAMPAMENTO",
"CANASGORDAS",
"CARACOLI",
"CARAMANTA",
"CAREPA",
"EL CARMEN DE VIBORAL",
"CAROLINA",
"CAUCASIA",
"CHIGORODO",
"CISNEROS",
"COCORNA",
"CONCEPCION",
"CONCORDIA",
"COPACABANA",
"DABEIBA",
"DON MATIAS",
"EBEJICO",
"EL BAGRE",
"ENTRERRIOS",
"ENVIGADO",
"FREDONIA",
"FRONTINO",
"GIRALDO",
"GIRARDOTA",
"GOMEZ PLATA",
"GRANADA",
"GUADALUPE",
"GUARNE",
"GUATAPE",
"HELICONIA",
"HISPANIA",
"ITAGUI",
"ITUANGO",
"JARDIN",
"JERICO",
"LA CEJA",
"LA ESTRELLA",
"LA PINTADA",
"LA UNION",
"LIBORINA",
"MACEO",
"MARINILLA",
"MONTEBELLO",
"MURINDO",
"MUTATA",
"NARINO",
"NECOCLI",
"NECHI",
"OLAYA",
"PENOL",
"PEQUE",
"PUEBLORRICO",
"PUERTO BERRIO",
"PUERTO NARE",
"PUERTO TRIUNFO",
"REMEDIOS",
"RETIRO",
"RIONEGRO",
"SABANALARGA",
"SABANETA",
"SALGAR",
"SAN ANDRES",
"SAN CARLOS",
"SAN FRANCISCO",
"SAN JERONIMO",
"SAN JOSE DE LA MONTANA",
"SAN JUAN DE URABA",
"SAN LUIS",
"SAN PEDRO",
"SAN PEDRO DE URABA",
"SAN RAFAEL",
"SAN ROQUE",
"SAN VICENTE",
"SANTA BARBARA",
"SANTA ROSA DE OSOS",
"SANTO DOMINGO",
"EL SANTUARIO",
"SEGOVIA",
"SONSON",
"SOPETRAN",
"TAMESIS",
"TARAZA",
"TARSO",
"TITIRIBI",
"TOLEDO",
"TURBO",
"URAMITA",
"URRAO",
"VALDIVIA",
"VALPARAISO",
"VEGACHI",
"VENECIA",
"VIGIA DEL FUERTE",
"YALI",
"YARUMAL",
"YOLOMBO",
"YONDO",
"ZARAGOZA",
"BARRANQUILLA",
"BARANOA",
"CAMPO DE LA CRUZ",
"CANDELARIA",
"GALAPA",
"JUAN DE ACOSTA",
"LURUACO",
"MALAMBO",
"MANATI",
"Palmar de Varela",
"PIOJO",
"POLONUEVO",
"PUERTO COLOMBIA",
"REPELON",
"SABANAGRANDE",
"SABANALARGA",
"SANTA LUCIA",
"SANTO TOMAS",
"SOLEDAD",
"SUAN",
"USIACURI",
"BOGOTA",
"CARTAGENA",
"ACHI",
"ALTOS DEL ROSARIO",
"ARJONA",
"ARROYOHONDO",
"BARRANCO DE LOBA",
"CALAMAR",
"CANTAGALLO",
"CICUCO",
"CORDOBA",
"CLEMENCIA",
"EL CARMEN DE BOLIVAR",
"EL GUAMO",
"EL PENON",
"HATILLO DE LOBA",
"MAGANGUE",
"MAHATES",
"MARGARITA",
"MARIA LA BAJA",
"MONTECRISTO",
"MOMPOS",
"MORALES",
"NOROSI",
"PINILLOS",
"REGIDOR",
"RIO VIEJO",
"SAN CRISTOBAL",
"SAN ESTANISLAO",
"SAN FERNANDO",
"SAN JACINTO",
"SAN JUAN NEPOMUCENO",
"SAN MARTIN DE LOBA",
"SAN PABLO",
"SANTA CATALINA",
"SANTA ROSA",
"SANTA ROSA DEL SUR",
"SIMITI",
"SOPLAVIENTO",
"TALAIGUA NUEVO",
"TIQUISIO",
"TURBACO",
"TURBANA",
"VILLANUEVA",
"ZAMBRANO",
"ISLA BARU",
"TUNJA",
"ALMEIDA",
"AQUITANIA",
"ARCABUCO",
"BELEN",
"BERBEO",
"BETEITIVA",
"BOAVITA",
"BOYACA",
"BRICENO",
"BUENAVISTA",
"BUSBANZA",
"CALDAS",
"CAMPOHERMOSO",
"CERINZA",
"CHINAVITA",
"CHIQUINQUIRA",
"CHISCAS",
"CHITA",
"CHITARAQUE",
"CHIVATA",
"CIENEGA",
"COMBITA",
"COPER",
"CORRALES",
"COVARACHIA",
"CUBARA",
"CUCAITA",
"CUITIVA",
"CHIQUIZA",
"CHIVOR",
"DUITAMA",
"EL COCUY",
"EL ESPINO",
"FIRAVITOBA",
"FLORESTA",
"GACHANTIVA",
"GAMEZA",
"GARAGOA",
"GUACAMAYAS",
"GUATEQUE",
"GUAYATA",
"GUICAN",
"IZA",
"JENESANO",
"JERICO",
"LABRANZAGRANDE",
"LA CAPILLA",
"LA VICTORIA",
"LA UVITA",
"VILLA DE LEYVA",
"MACANAL",
"MARIPI",
"MIRAFLORES",
"MONGUA",
"MONGUI",
"MONIQUIRA",
"MOTAVITA",
"MUZO",
"NOBSA",
"NUEVO COLON",
"OICATA",
"OTANCHE",
"PACHAVITA",
"PAEZ",
"PAIPA",
"PAJARITO",
"PANQUEBA",
"PAUNA",
"PAYA",
"PAZ DE RIO",
"PESCA",
"PISBA",
"PUERTO BOYACA",
"QUIPAMA",
"RAMIRIQUI",
"RAQUIRA",
"RONDON",
"SABOYA",
"SACHICA",
"SAMACA",
"SAN EDUARDO",
"SAN JOSE DE PARE",
"SAN LUIS DE GACENO",
"SAN MATEO",
"SAN MIGUEL DE SEMA",
"SAN PABLO DE BORBUR",
"SANTANA",
"SANTA MARIA-BOY",
"SANTA ROSA DE VITERBO",
"SANTA SOFIA",
"SATIVANORTE",
"SATIVASUR",
"SIACHOQUE",
"SOATA",
"SOCOTA",
"SOCHA",
"SOGAMOSO",
"SOMONDOCO",
"SORA",
"SOTAQUIRA",
"SORACA",
"SUSACON",
"SUTAMARCHAN",
"SUTATENZA",
"TASCO",
"TENZA",
"TIBANA",
"TIBASOSA",
"TINJACA",
"TIPACOQUE",
"TOCA",
"TOGUI",
"TOPAGA",
"TOTA",
"TURMEQUE",
"TUTA",
"TUTAZA",
"UMBITA",
"VENTAQUEMADA",
"VIRACACHA",
"ZETAQUIRA",
"MANIZALES",
"AGUADAS",
"ANSERMA",
"ARANZAZU",
"BELALCAZAR",
"CHINCHINA",
"FILADELFIA",
"LA DORADA",
"LA MERCED",
"MANZANARES",
"MARMATO",
"MARQUETALIA",
"MARULANDA",
"NEIRA",
"NORCASIA",
"PACORA",
"PALESTINA",
"PENSILVANIA",
"RIOSUCIO",
"RISARALDA",
"SALAMINA",
"SAMANA",
"SAN JOSE",
"SUPIA",
"VICTORIA",
"VILLAMARIA",
"VITERBO",
"FLORENCIA",
"ALBANIA",
"BELEN DE LOS ANDAQUIES",
"CARTAGENA DEL CHAIRA",
"CURILLO",
"EL DONCELLO",
"EL PAUJIL",
"LA MONTANITA",
"MILAN",
"MORELIA",
"PUERTO RICO",
"SAN JOSE DEL FRAGUA",
"SAN VICENTE DEL CAGUAN",
"SOLANO",
"SOLITA",
"VALPARAISO",
"POPAYAN",
"ALMAGUER",
"ARGELIA",
"BALBOA",
"BOLIVAR",
"BUENOS AIRES",
"CAJIBIO",
"CALDONO",
"CALOTO",
"CORINTO",
"EL TAMBO",
"GUACHENE",
"GUAPI",
"INZA",
"JAMBALO",
"LA SIERRA",
"LA VEGA",
"MERCADERES",
"MIRANDA",
"MORALES",
"PADILLA",
"PATIA",
"PIAMONTE",
"PIENDAMO",
"PUERTO TEJADA",
"PURACE",
"ROSAS",
"SAN SEBASTIAN",
"SANTANDER DE QUILICHAO",
"SILVIA",
"SOTARA",
"SUAREZ",
"SUCRE",
"TIMBIO",
"TIMBIQUI",
"TORIBIO",
"TOTORO",
"VILLA RICA",
"VALLEDUPAR",
"AGUACHICA",
"AGUSTIN CODAZZI",
"ASTREA",
"BECERRIL",
"BOSCONIA",
"CHIMICHAGUA",
"CHIRIGUANA",
"CURUMANI",
"EL COPEY",
"EL PASO",
"GAMARRA",
"GONZALEZ",
"LA GLORIA",
"LA JAGUA DE IBIRICO",
"MANAURE",
"PAILITAS",
"PELAYA",
"PUEBLO BELLO",
"RIO DE ORO",
"LA PAZ",
"SAN ALBERTO",
"SAN DIEGO",
"SAN MARTIN",
"TAMALAMEQUE",
"MONTERIA",
"AYAPEL",
"BUENAVISTA",
"CANALETE",
"CERETE",
"CHIMA",
"CHINU",
"CIENAGA DE ORO",
"LA APARTADA",
"LORICA",
"LOS CORDOBAS",
"MOMIL",
"MONTELIBANO",
"MONITOS",
"PLANETA RICA",
"PUEBLO NUEVO",
"PUERTO ESCONDIDO",
"PUERTO LIBERTADOR",
"SAHAGUN",
"SAN ANDRES SOTAVENTO",
"SAN ANTERO",
"SAN BERNARDO DEL VIENTO",
"SAN CARLOS",
"SAN PELAYO",
"TIERRALTA",
"VALENCIA",
"AGUA DE DIOS",
"ALBAN",
"ANAPOIMA",
"ANOLAIMA",
"ARBELAEZ",
"BELTRAN",
"BITUIMA",
"BOJACA",
"CABRERA",
"CACHIPAY",
"CAJICA",
"CAPARRAPI",
"CAQUEZA",
"CARMEN DE CARUPA",
"CHAGUANI",
"CHIA",
"CHIPAQUE",
"CHOACHI",
"CHOCONTA",
"COGUA",
"COTA",
"CUCUNUBA",
"EL COLEGIO",
"EL PENON",
"EL ROSAL",
"FACATATIVA",
"FOMEQUE",
"FOSCA",
"FUNZA",
"FUQUENE",
"FUSAGASUGA",
"GACHALA",
"GACHANCIPA",
"GACHETA",
"GAMA",
"GIRARDOT",
"GRANADA",
"GUACHETA",
"GUADUAS",
"GUASCA",
"GUATAQUI",
"GUATAVITA",
"GUAYABAL DE SIQUIMA",
"GUAYABETAL",
"GUTIERREZ",
"JERUSALEN",
"JUNIN",
"LA CALERA",
"LA MESA",
"LA PALMA",
"LA PENA",
"LA VEGA",
"LENGUAZAQUE",
"MACHETA",
"MADRID",
"MANTA",
"MEDINA",
"MOSQUERA",
"NARINO",
"NEMOCON",
"NILO",
"NIMAIMA",
"NOCAIMA",
"PACHO",
"PAIME",
"PANDI",
"PARATEBUENO",
"PASCA",
"PUERTO SALGAR",
"PULI",
"QUEBRADANEGRA",
"QUETAME",
"QUIPILE",
"APULO",
"RICAURTE",
"SAN ANTONIO DEL TEQUENDAMA",
"SAN BERNARDO",
"SAN CAYETANO",
"SAN FRANCISCO",
"SAN JUAN DE RIO SECO",
"SASAIMA",
"SESQUILE",
"SIBATE",
"SILVANIA",
"SIMIJACA",
"SOACHA",
"SOPO",
"SUBACHOQUE",
"SUESCA",
"SUPATA",
"SUSA",
"SUTATAUSA",
"TABIO",
"TAUSA",
"TENA",
"TENJO",
"TIBACUY",
"TIBIRITA",
"TOCAIMA",
"TOCANCIPA",
"TOPAIPI",
"UBALA",
"UBAQUE",
"UBATE",
"UNE",
"UTICA",
"VERGARA",
"VIANI",
"VILLAGOMEZ",
"VILLAPINZON",
"VILLETA",
"VIOTA",
"YACOPI",
"ZIPACON",
"ZIPAQUIRA",
"QUIBDO",
"ACANDI",
"ALTO BAUDO",
"ATRATO",
"BAGADO",
"BAHIA SOLANO",
"BAJO BAUDO",
"BOJAYA",
"EL CANTON DEL SAN PABLO",
"CONDOTO",
"EL CARMEN DE ATRATO",
"ISTMINA",
"JURADO",
"LLORO",
"MEDIO ATRATO",
"MEDIO BAUDO",
"NOVITA",
"NUQUI",
"RIO QUITO",
"RIOSUCIO",
"SIPI",
"TADO",
"UNGUIA",
"NEIVA",
"ACEVEDO",
"AGRADO",
"AIPE",
"ALGECIRAS",
"BARAYA",
"CAMPOALEGRE",
"COLOMBIA",
"ELIAS",
"GARZON",
"GIGANTE",
"GUADALUPE",
"IQUIRA",
"ISNOS",
"LA ARGENTINA",
"LA PLATA",
"NATAGA",
"OPORAPA",
"PAICOL",
"PALERMO",
"PITAL",
"PITALITO",
"RIVERA",
"SALADOBLANCO",
"SAN AGUSTIN",
"SANTA MARIA",
"SUAZA",
"TARQUI",
"TESALIA",
"TELLO",
"TERUEL",
"TIMANA",
"VILLAVIEJA",
"YAGUARA",
"RIOHACHA",
"ALBANIA",
"BARRANCAS",
"DIBULLA",
"DISTRACCION",
"EL MOLINO",
"FONSECA",
"HATONUEVO",
"LA JAGUA DEL PILAR",
"MAICAO",
"MANAURE",
"SAN JUAN DEL CESAR",
"URIBIA",
"URUMITA",
"VILLANUEVA",
"SANTA MARTA",
"ARACATACA",
"ARIGUANI",
"CERRO SAN ANTONIO",
"CHIBOLO",
"CIENAGA",
"EL BANCO",
"EL PINON",
"FUNDACION",
"GUAMAL",
"PEDRAZA",
"PIJINO DEL CARMEN",
"PIVIJAY",
"PLATO",
"REMOLINO",
"SABANAS DE SAN ANGEL",
"SALAMINA",
"SAN SEBASTIAN DE BUENAVISTA",
"SAN ZENON",
"SANTA ANA",
"SITIONUEVO",
"TENERIFE",
"VILLAVICENCIO",
"ACACIAS",
"BARRANCA DE UPIA",
"CABUYARO",
"CASTILLA LA NUEVA",
"CUMARAL",
"EL CALVARIO",
"EL CASTILLO",
"EL DORADO",
"FUENTE DE ORO",
"GRANADA",
"GUAMAL",
"MAPIRIPAN",
"MESETAS",
"LA MACARENA",
"URIBE",
"LEJANIAS",
"PUERTO CONCORDIA",
"PUERTO GAITAN",
"PUERTO LOPEZ",
"PUERTO LLERAS",
"PUERTO RICO",
"RESTREPO",
"SAN CARLOS DE GUAROA",
"SAN JUAN DE ARAMA",
"SAN JUANITO",
"SAN MARTIN",
"VISTAHERMOSA",
"PASTO",
"ALBAN",
"ALDANA",
"ANCUYA",
"ARBOLEDA",
"BARBACOAS",
"BELEN",
"BUESACO",
"COLON",
"CONSACA",
"CONTADERO",
"CORDOBA",
"CUASPUD",
"CUMBAL",
"CUMBITARA",
"CHACHAGUI",
"EL CHARCO",
"EL PENOL",
"EL ROSARIO",
"EL TABLON DE GOMEZ",
"EL TAMBO",
"FUNES",
"GUACHUCAL",
"GUAITARILLA",
"IMUES",
"IPIALES",
"LA CRUZ",
"LA FLORIDA",
"LA LLANADA",
"LA TOLA",
"LA UNION",
"LEIVA",
"LINARES",
"LOS ANDES",
"MAGUI",
"MALLAMA",
"MOSQUERA",
"NARINO",
"OSPINA",
"POLICARPA",
"POTOSI",
"PROVIDENCIA",
"PUERRES",
"PUPIALES",
"RICAURTE",
"SAMANIEGO",
"SANDONA",
"SAN BERNARDO",
"SAN LORENZO",
"SAN PABLO",
"SAN PEDRO DE CARTAGO",
"SAPUYES",
"TAMINANGO",
"TANGUA",
"TUMACO",
"TUQUERRES",
"YACUANQUER",
"CUCUTA",
"ABREGO",
"ARBOLEDAS",
"BOCHALEMA",
"BUCARASICA",
"CACOTA",
"CACHIRA",
"CHINACOTA",
"CHITAGA",
"CONVENCION",
"CUCUTILLA",
"DURANIA",
"EL CARMEN",
"EL TARRA",
"EL ZULIA",
"GRAMALOTE",
"HACARI",
"HERRAN",
"LABATECA",
"LA PLAYA",
"LOS PATIOS",
"LOURDES",
"MUTISCUA",
"OCANA",
"PAMPLONA",
"PAMPLONITA",
"PUERTO SANTANDER",
"RAGONVALIA",
"SALAZAR",
"SAN CALIXTO",
"SAN CAYETANO",
"SANTIAGO",
"SARDINATA",
"SILOS",
"TEORAMA",
"TIBU",
"TOLEDO",
"VILLA CARO",
"VILLA DEL ROSARIO",
"ARMENIA",
"BUENAVISTA",
"CALARCA",
"CIRCASIA",
"CORDOBA",
"FILANDIA",
"GENOVA",
"LA TEBAIDA",
"MONTENEGRO",
"PIJAO",
"QUIMBAYA",
"SALENTO",
"PEREIRA",
"APIA",
"BALBOA",
"BELEN DE UMBRIA",
"DOSQUEBRADAS",
"GUATICA",
"LA CELIA",
"LA VIRGINIA",
"MARSELLA",
"MISTRATO",
"PUEBLO RICO",
"QUINCHIA",
"SANTA ROSA DE CABAL",
"SANTUARIO",
"BUCARAMANGA",
"AGUADA",
"ALBANIA",
"ARATOCA",
"BARBOSA",
"BARICHARA",
"BARRANCABERMEJA",
"BETULIA",
"BOLIVAR",
"CABRERA",
"CALIFORNIA",
"CAPITANEJO",
"CARCASI",
"CEPITA",
"CERRITO",
"CHARALA",
"CHARTA",
"CIMITARRA",
"CONCEPCION",
"CONFINES",
"CONTRATACION",
"COROMORO",
"CURITI",
"EL CARMEN DE CHUCURI",
"EL GUACAMAYO",
"EL PENON",
"ENCINO",
"FLORIAN",
"FLORIDABLANCA",
"GALAN",
"GAMBITA",
"GIRON",
"GUAPOTA",
"GUAVATA",
"GUEPSA",
"HATO",
"JESUS MARIA",
"JORDAN",
"LA BELLEZA",
"LANDAZURI",
"LEBRIJA",
"LOS SANTOS",
"MACARAVITA",
"MALAGA",
"MATANZA",
"MOGOTES",
"MOLAGAVITA",
"OCAMONTE",
"ONZAGA",
"PALMAR",
"PALMAS DEL SOCORRO",
"PARAMO",
"PIEDECUESTA",
"PINCHOTE",
"PUENTE NACIONAL",
"PUERTO PARRA",
"PUERTO WILCHES",
"RIONEGRO",
"SABANA DE TORRES",
"SAN ANDRES",
"SAN BENITO",
"SAN GIL",
"SAN JOAQUIN",
"SAN JOSE DE MIRANDA",
"SAN MIGUEL",
"SAN VICENTE DE CHUCURI",
"SANTA BARBARA",
"SANTA HELENA DEL OPON",
"SIMACOTA",
"SOCORRO",
"SUAITA",
"SUCRE",
"SURATA",
"TONA",
"VALLE DE SAN JOSE",
"VELEZ",
"VETAS",
"VILLANUEVA",
"ZAPATOCA",
"SINCELEJO",
"COLOSO",
"COROZAL",
"COVENAS",
"CHALAN",
"EL ROBLE",
"GALERAS",
"GUARANDA",
"LOS PALMITOS",
"MAJAGUAL",
"MORROA",
"OVEJAS",
"PALMITO",
"SAMPUES",
"SAN BENITO ABAD",
"SAN JUAN DE BETULIA",
"SAN MARCOS",
"SAN ONOFRE",
"SAN PEDRO",
"SINCE",
"SUCRE",
"SANTIAGO DE TOLU",
"TOLUVIEJO",
"IBAGUE",
"ALPUJARRA",
"ALVARADO",
"AMBALEMA",
"ANZOATEGUI",
"ARMERO",
"ATACO",
"CAJAMARCA",
"CARMEN DE APICALA",
"CASABIANCA",
"CHAPARRAL",
"COYAIMA",
"CUNDAY",
"DOLORES",
"ESPINAL",
"FALAN",
"FLANDES",
"FRESNO",
"GUAMO",
"HERVEO",
"HONDA",
"ICONONZO",
"LERIDA",
"LIBANO",
"MARIQUITA",
"MELGAR",
"MURILLO",
"NATAGAIMA",
"ORTEGA",
"PALOCABILDO",
"PIEDRAS",
"PLANADAS",
"PRADO",
"PURIFICACION",
"RIOBLANCO",
"RONCESVALLES",
"ROVIRA",
"SALDANA",
"SAN ANTONIO",
"SANTA ISABEL",
"VALLE DE SAN JUAN",
"VENADILLO",
"VILLAHERMOSA",
"VILLARRICA",
"CALI",
"ALCALA",
"ANDALUCIA",
"ANSERMANUEVO",
"ARGELIA",
"BOLIVAR",
"BUENAVENTURA",
"BUGA",
"BUGALAGRANDE",
"CAICEDONIA",
"CALIMA",
"CANDELARIA",
"CARTAGO",
"DAGUA",
"EL AGUILA",
"EL CAIRO",
"EL CERRITO",
"EL DOVIO",
"FLORIDA",
"GINEBRA",
"GUACARI",
"JAMUNDI",
"LA CUMBRE",
"LA UNION",
"LA VICTORIA",
"OBANDO",
"PALMIRA",
"PRADERA",
"RESTREPO",
"RIOFRIO",
"ROLDANILLO",
"SAN PEDRO",
"SEVILLA",
"TORO",
"TRUJILLO",
"TULUA",
"ULLOA",
"VERSALLES",
"VIJES",
"YOTOCO",
"YUMBO",
"ZARZAL",
"ARAUCA",
"ARAUQUITA",
"CRAVO NORTE",
"FORTUL",
"PUERTO RONDON",
"SARAVENA",
"TAME",
"YOPAL",
"AGUAZUL",
"CHAMEZA",
"HATO COROZAL",
"LA SALINA",
"MANI",
"MONTERREY",
"NUNCHIA",
"OROCUE",
"PAZ DE ARIPORO",
"PORE",
"RECETOR",
"SABANALARGA",
"SACAMA",
"SAN LUIS DE PALENQUE",
"TAMARA",
"TAURAMENA",
"TRINIDAD",
"VILLANUEVA",
"MOCOA",
"COLON",
"ORITO",
"PUERTO ASIS",
"PUERTO CAICEDO",
"PUERTO GUZMAN",
"PUERTO LEGUIZAMO",
"SIBUNDOY",
"SAN FRANCISCO",
"SAN MIGUEL",
"SANTIAGO",
"VALLE DEL GUAMUEZ",
"VILLAGARZON",
"SAN ANDRES-SAP",
"PROVIDENCIA",
"LETICIA",
"EL ENCANTO",
"LA CHORRERA",
"LA PEDRERA",
"LA VICTORIA",
"MIRITI - PARANA",
"PUERTO ALEGRIA",
"PUERTO ARICA",
"PUERTO NARINO",
"TARAPACA",
"INIRIDA",
"SAN FELIPE",
"PUERTO COLOMBIA",
"CACAHUAL",
"SAN JOSE DEL GUAVIARE",
"EL RETORNO",
"MIRAFLORES",
"MITU",
"CARURU",
"PUERTO CARRENO",
"LA PRIMAVERA",
"SANTA ROSALIA",
"CUMARIBO",
"RIOHACHA",
"ALBANIA-LAG",
"BARRANCAS",
"DIBULLA",
"DISTRACCION",
"EL MOLINO",
"FONSECA",
"HATONUEVO",
"LA JAGUA DEL PILAR",
"MAICAO",
"MANAURE",
"SAN JUAN DEL CESAR",
"URIBIA",
"URUMITA",
"VILLANUEVA-LAG",
"MEDELLIN",
"ABEJORRAL",
"ABRIAQUI",
"ALEJANDRIA",
"AMAGA",
"AMALFI",
"ANDES",
"ANGELOPOLIS",
"ANGOSTURA",
"ANORI",
"SANTAFE DE ANTIOQUIA",
"ANZA",
"APARTADO",
"ARBOLETES",
"ARGELIA",
"MANTEQUILLA ARMENIA",
"BARBOSA",
"BELMIRA",
"BELLO",
"BETANIA",
"BETULIA",
"CIUDAD BOLIVAR",
"BRICENO",
"BURITICA",
"CACERES",
"CAICEDO",
"CALDAS",
"CAMPAMENTO",
"CANASGORDAS",
"CARACOLI",
"CARAMANTA",
"CAREPA",
"EL CARMEN DE VIBORAL",
"CAROLINA",
"CAUCASIA",
"CHIGORODO",
"CISNEROS",
"COCORNA",
"CONCEPCION",
"CONCORDIA",
"COPACABANA",
"DABEIBA",
"DON MATIAS",
"EBEJICO",
"EL BAGRE",
"ENTRERRIOS",
"ENVIGADO",
"FREDONIA",
"FRONTINO",
"GIRALDO",
"GIRARDOTA",
"GOMEZ PLATA",
"GRANADA",
"GUADALUPE",
"GUARNE",
"GUATAPE",
"HELICONIA",
"HISPANIA",
"ITAGUI",
"ITUANGO",
"JARDIN",
"JERICO",
"LA CEJA",
"LA ESTRELLA",
"LA PINTADA",
"LA UNION",
"LIBORINA",
"MACEO",
"MARINILLA",
"MONTEBELLO",
"MURINDO",
"MUTATA",
"NARINO",
"NECOCLI",
"NECHI",
"OLAYA",
"PENOL",
"PEQUE",
"PUEBLORRICO",
"PUERTO BERRIO",
"PUERTO NARE",
"PUERTO TRIUNFO",
"REMEDIOS",
"RETIRO",
"RIONEGRO",
"SABANALARGA",
"SABANETA",
"SALGAR",
"SAN ANDRES",
"SAN CARLOS",
"SAN FRANCISCO",
"SAN JERONIMO",
"SAN JOSE DE LA MONTANA",
"SAN JUAN DE URABA",
"SAN LUIS",
"SAN PEDRO",
"SAN PEDRO DE URABA",
"SAN RAFAEL",
"SAN ROQUE",
"SAN VICENTE",
"SANTA BARBARA",
"SANTA ROSA DE OSOS",
"SANTO DOMINGO",
"EL SANTUARIO",
"SEGOVIA",
"SONSON",
"SOPETRAN",
"TAMESIS",
"TARAZA",
"TARSO",
"TITIRIBI",
"TOLEDO",
"TURBO",
"URAMITA",
"URRAO",
"VALDIVIA",
"VALPARAISO",
"VEGACHI",
"VENECIA",
"VIGIA DEL FUERTE",
"YALI",
"YARUMAL",
"YOLOMBO",
"YONDO",
"ZARAGOZA",
"BARRANQUILLA",
"BARANOA",
"CAMPO DE LA CRUZ",
"CANDELARIA",
"GALAPA",
"JUAN DE ACOSTA",
"LURUACO",
"MALAMBO",
"MANATI",
"Palmar de Varela",
"PIOJO",
"POLONUEVO",
"PUERTO COLOMBIA",
"REPELON",
"SABANAGRANDE",
"SABANALARGA",
"SANTA LUCIA",
"SANTO TOMAS",
"SOLEDAD",
"SUAN",
"USIACURI",
"BOGOTA",
"CARTAGENA",
"ACHI",
"ALTOS DEL ROSARIO",
"ARJONA",
"ARROYOHONDO",
"BARRANCO DE LOBA",
"CALAMAR",
"CANTAGALLO",
"CICUCO",
"CORDOBA",
"CLEMENCIA",
"EL CARMEN DE BOLIVAR",
"EL GUAMO",
"EL PENON",
"HATILLO DE LOBA",
"MAGANGUE",
"MAHATES",
"MARGARITA",
"MARIA LA BAJA",
"MONTECRISTO",
"MOMPOS",
"MORALES",
"NOROSI",
"PINILLOS",
"REGIDOR",
"RIO VIEJO",
"SAN CRISTOBAL",
"SAN ESTANISLAO",
"SAN FERNANDO",
"SAN JACINTO",
"SAN JUAN NEPOMUCENO",
"SAN MARTIN DE LOBA",
"SAN PABLO",
"SANTA CATALINA",
"SANTA ROSA",
"SANTA ROSA DEL SUR",
"SIMITI",
"SOPLAVIENTO",
"TALAIGUA NUEVO",
"TIQUISIO",
"TURBACO",
"TURBANA",
"VILLANUEVA",
"ZAMBRANO",
"ISLA BARU",
"TUNJA",
"ALMEIDA",
"AQUITANIA",
"ARCABUCO",
"BELEN",
"BERBEO",
"BETEITIVA",
"BOAVITA",
"BOYACA",
"BRICENO",
"BUENAVISTA",
"BUSBANZA",
"CALDAS",
"CAMPOHERMOSO",
"CERINZA",
"CHINAVITA",
"CHIQUINQUIRA",
"CHISCAS",
"CHITA",
"CHITARAQUE",
"CHIVATA",
"CIENEGA",
"COMBITA",
"COPER",
"CORRALES",
"COVARACHIA",
"CUBARA",
"CUCAITA",
"CUITIVA",
"CHIQUIZA",
"CHIVOR",
"DUITAMA",
"EL COCUY",
"EL ESPINO",
"FIRAVITOBA",
"FLORESTA",
"GACHANTIVA",
"GAMEZA",
"GARAGOA",
"GUACAMAYAS",
"GUATEQUE",
"GUAYATA",
"GUICAN",
"IZA",
"JENESANO",
"JERICO",
"LABRANZAGRANDE",
"LA CAPILLA",
"LA VICTORIA",
"LA UVITA",
"VILLA DE LEYVA",
"MACANAL",
"MARIPI",
"MIRAFLORES",
"MONGUA",
"MONGUI",
"MONIQUIRA",
"MOTAVITA",
"MUZO",
"NOBSA",
"NUEVO COLON",
"OICATA",
"OTANCHE",
"PACHAVITA",
"PAEZ",
"PAIPA",
"PAJARITO",
"PANQUEBA",
"PAUNA",
"PAYA",
"PAZ DE RIO",
"PESCA",
"PISBA",
"PUERTO BOYACA",
"QUIPAMA",
"RAMIRIQUI",
"RAQUIRA",
"RONDON",
"SABOYA",
"SACHICA",
"SAMACA",
"SAN EDUARDO",
"SAN JOSE DE PARE",
"SAN LUIS DE GACENO",
"SAN MATEO",
"SAN MIGUEL DE SEMA",
"SAN PABLO DE BORBUR",
"SANTANA",
"SANTA MARIA-BOY",
"SANTA ROSA DE VITERBO",
"SANTA SOFIA",
"SATIVANORTE",
"SATIVASUR",
"SIACHOQUE",
"SOATA",
"SOCOTA",
"SOCHA",
"SOGAMOSO",
"SOMONDOCO",
"SORA",
"SOTAQUIRA",
"SORACA",
"SUSACON",
"SUTAMARCHAN",
"SUTATENZA",
"TASCO",
"TENZA",
"TIBANA",
"TIBASOSA",
"TINJACA",
"TIPACOQUE",
"TOCA",
"TOGUI",
"TOPAGA",
"TOTA",
"TURMEQUE",
"TUTA",
"TUTAZA",
"UMBITA",
"VENTAQUEMADA",
"VIRACACHA",
"ZETAQUIRA",
"MANIZALES",
"AGUADAS",
"ANSERMA",
"ARANZAZU",
"BELALCAZAR",
"CHINCHINA",
"FILADELFIA",
"LA DORADA",
"LA MERCED",
"MANZANARES",
"MARMATO",
"MARQUETALIA",
"MARULANDA",
"NEIRA",
"NORCASIA",
"PACORA",
"PALESTINA",
"PENSILVANIA",
"RIOSUCIO",
"RISARALDA",
"SALAMINA",
"SAMANA",
"SAN JOSE",
"SUPIA",
"VICTORIA",
"VILLAMARIA",
"VITERBO",
"FLORENCIA",
"ALBANIA",
"BELEN DE LOS ANDAQUIES",
"CARTAGENA DEL CHAIRA",
"CURILLO",
"EL DONCELLO",
"EL PAUJIL",
"LA MONTANITA",
"MILAN",
"MORELIA",
"PUERTO RICO",
"SAN JOSE DEL FRAGUA",
"SAN VICENTE DEL CAGUAN",
"SOLANO",
"SOLITA",
"VALPARAISO",
"POPAYAN",
"ALMAGUER",
"ARGELIA",
"BALBOA",
"BOLIVAR",
"BUENOS AIRES",
"CAJIBIO",
"CALDONO",
"CALOTO",
"CORINTO",
"EL TAMBO",
"GUACHENE",
"GUAPI",
"INZA",
"JAMBALO",
"LA SIERRA",
"LA VEGA",
"MERCADERES",
"MIRANDA",
"MORALES",
"PADILLA",
"PATIA",
"PIAMONTE",
"PIENDAMO",
"PUERTO TEJADA",
"PURACE",
"ROSAS",
"SAN SEBASTIAN",
"SANTANDER DE QUILICHAO",
"SILVIA",
"SOTARA",
"SUAREZ",
"SUCRE",
"TIMBIO",
"TIMBIQUI",
"TORIBIO",
"TOTORO",
"VILLA RICA",
"VALLEDUPAR",
"AGUACHICA",
"AGUSTIN CODAZZI",
"ASTREA",
"BECERRIL",
"BOSCONIA",
"CHIMICHAGUA",
"CHIRIGUANA",
"CURUMANI",
"EL COPEY",
"EL PASO",
"GAMARRA",
"GONZALEZ",
"LA GLORIA",
"LA JAGUA DE IBIRICO",
"MANAURE",
"PAILITAS",
"PELAYA",
"PUEBLO BELLO",
"RIO DE ORO",
"LA PAZ",
"SAN ALBERTO",
"SAN DIEGO",
"SAN MARTIN",
"TAMALAMEQUE",
"MONTERIA",
"AYAPEL",
"BUENAVISTA",
"CANALETE",
"CERETE",
"CHIMA",
"CHINU",
"CIENAGA DE ORO",
"LA APARTADA",
"LORICA",
"LOS CORDOBAS",
"MOMIL",
"MONTELIBANO",
"MONITOS",
"PLANETA RICA",
"PUEBLO NUEVO",
"PUERTO ESCONDIDO",
"PUERTO LIBERTADOR",
"SAHAGUN",
"SAN ANDRES SOTAVENTO",
"SAN ANTERO",
"SAN BERNARDO DEL VIENTO",
"SAN CARLOS",
"SAN PELAYO",
"TIERRALTA",
"VALENCIA",
"AGUA DE DIOS",
"ALBAN",
"ANAPOIMA",
"ANOLAIMA",
"ARBELAEZ",
"BELTRAN",
"BITUIMA",
"BOJACA",
"CABRERA",
"CACHIPAY",
"CAJICA",
"CAPARRAPI",
"CAQUEZA",
"CARMEN DE CARUPA",
"CHAGUANI",
"CHIA",
"CHIPAQUE",
"CHOACHI",
"CHOCONTA",
"COGUA",
"COTA",
"CUCUNUBA",
"EL COLEGIO",
"EL PENON",
"EL ROSAL",
"FACATATIVA",
"FOMEQUE",
"FOSCA",
"FUNZA",
"FUQUENE",
"FUSAGASUGA",
"GACHALA",
"GACHANCIPA",
"GACHETA",
"GAMA",
"GIRARDOT",
"GRANADA",
"GUACHETA",
"GUADUAS",
"GUASCA",
"GUATAQUI",
"GUATAVITA",
"GUAYABAL DE SIQUIMA",
"GUAYABETAL",
"GUTIERREZ",
"JERUSALEN",
"JUNIN",
"LA CALERA",
"LA MESA",
"LA PALMA",
"LA PENA",
"LA VEGA",
"LENGUAZAQUE",
"MACHETA",
"MADRID",
"MANTA",
"MEDINA",
"MOSQUERA",
"NARINO",
"NEMOCON",
"NILO",
"NIMAIMA",
"NOCAIMA",
"PACHO",
"PAIME",
"PANDI",
"PARATEBUENO",
"PASCA",
"PUERTO SALGAR",
"PULI",
"QUEBRADANEGRA",
"QUETAME",
"QUIPILE",
"APULO",
"RICAURTE",
"SAN ANTONIO DEL TEQUENDAMA",
"SAN BERNARDO",
"SAN CAYETANO",
"SAN FRANCISCO",
"SAN JUAN DE RIO SECO",
"SASAIMA",
"SESQUILE",
"SIBATE",
"SILVANIA",
"SIMIJACA",
"SOACHA",
"SOPO",
"SUBACHOQUE",
"SUESCA",
"SUPATA",
"SUSA",
"SUTATAUSA",
"TABIO",
"TAUSA",
"TENA",
"TENJO",
"TIBACUY",
"TIBIRITA",
"TOCAIMA",
"TOCANCIPA",
"TOPAIPI",
"UBALA",
"UBAQUE",
"UBATE",
"UNE",
"UTICA",
"VERGARA",
"VIANI",
"VILLAGOMEZ",
"VILLAPINZON",
"VILLETA",
"VIOTA",
"YACOPI",
"ZIPACON",
"ZIPAQUIRA",
"QUIBDO",
"ACANDI",
"ALTO BAUDO",
"ATRATO",
"BAGADO",
"BAHIA SOLANO",
"BAJO BAUDO",
"BOJAYA",
"EL CANTON DEL SAN PABLO",
"CONDOTO",
"EL CARMEN DE ATRATO",
"ISTMINA",
"JURADO",
"LLORO",
"MEDIO ATRATO",
"MEDIO BAUDO",
"NOVITA",
"NUQUI",
"RIO QUITO",
"RIOSUCIO",
"SIPI",
"TADO",
"UNGUIA",
"NEIVA",
"ACEVEDO",
"AGRADO",
"AIPE",
"ALGECIRAS",
"BARAYA",
"CAMPOALEGRE",
"COLOMBIA",
"ELIAS",
"GARZON",
"GIGANTE",
"GUADALUPE",
"IQUIRA",
"ISNOS",
"LA ARGENTINA",
"LA PLATA",
"NATAGA",
"OPORAPA",
"PAICOL",
"PALERMO",
"PITAL",
"PITALITO",
"RIVERA",
"SALADOBLANCO",
"SAN AGUSTIN",
"SANTA MARIA",
"SUAZA",
"TARQUI",
"TESALIA",
"TELLO",
"TERUEL",
"TIMANA",
"VILLAVIEJA",
"YAGUARA",
"RIOHACHA",
"ALBANIA",
"BARRANCAS",
"DIBULLA",
"DISTRACCION",
"EL MOLINO",
"FONSECA",
"HATONUEVO",
"LA JAGUA DEL PILAR",
"MAICAO",
"MANAURE",
"SAN JUAN DEL CESAR",
"URIBIA",
"URUMITA",
"VILLANUEVA",
"SANTA MARTA",
"ARACATACA",
"ARIGUANI",
"CERRO SAN ANTONIO",
"CHIBOLO",
"CIENAGA",
"EL BANCO",
"EL PINON",
"FUNDACION",
"GUAMAL",
"PEDRAZA",
"PIJINO DEL CARMEN",
"PIVIJAY",
"PLATO",
"REMOLINO",
"SABANAS DE SAN ANGEL",
"SALAMINA",
"SAN SEBASTIAN DE BUENAVISTA",
"SAN ZENON",
"SANTA ANA",
"SITIONUEVO",
"TENERIFE",
"VILLAVICENCIO",
"ACACIAS",
"BARRANCA DE UPIA",
"CABUYARO",
"CASTILLA LA NUEVA",
"CUMARAL",
"EL CALVARIO",
"EL CASTILLO",
"EL DORADO",
"FUENTE DE ORO",
"GRANADA",
"GUAMAL",
"MAPIRIPAN",
"MESETAS",
"LA MACARENA",
"URIBE",
"LEJANIAS",
"PUERTO CONCORDIA",
"PUERTO GAITAN",
"PUERTO LOPEZ",
"PUERTO LLERAS",
"PUERTO RICO",
"RESTREPO",
"SAN CARLOS DE GUAROA",
"SAN JUAN DE ARAMA",
"SAN JUANITO",
"SAN MARTIN",
"VISTAHERMOSA",
"PASTO",
"ALBAN",
"ALDANA",
"ANCUYA",
"ARBOLEDA",
"BARBACOAS",
"BELEN",
"BUESACO",
"COLON",
"CONSACA",
"CONTADERO",
"CORDOBA",
"CUASPUD",
"CUMBAL",
"CUMBITARA",
"CHACHAGUI",
"EL CHARCO",
"EL PENOL",
"EL ROSARIO",
"EL TABLON DE GOMEZ",
"EL TAMBO",
"FUNES",
"GUACHUCAL",
"GUAITARILLA",
"IMUES",
"IPIALES",
"LA CRUZ",
"LA FLORIDA",
"LA LLANADA",
"LA TOLA",
"LA UNION",
"LEIVA",
"LINARES",
"LOS ANDES",
"MAGUI",
"MALLAMA",
"MOSQUERA",
"NARINO",
"OSPINA",
"POLICARPA",
"POTOSI",
"PROVIDENCIA",
"PUERRES",
"PUPIALES",
"RICAURTE",
"SAMANIEGO",
"SANDONA",
"SAN BERNARDO",
"SAN LORENZO",
"SAN PABLO",
"SAN PEDRO DE CARTAGO",
"SAPUYES",
"TAMINANGO",
"TANGUA",
"TUMACO",
"TUQUERRES",
"YACUANQUER",
"CUCUTA",
"ABREGO",
"ARBOLEDAS",
"BOCHALEMA",
"BUCARASICA",
"CACOTA",
"CACHIRA",
"CHINACOTA",
"CHITAGA",
"CONVENCION",
"CUCUTILLA",
"DURANIA",
"EL CARMEN",
"EL TARRA",
"EL ZULIA",
"GRAMALOTE",
"HACARI",
"HERRAN",
"LABATECA",
"LA PLAYA",
"LOS PATIOS",
"LOURDES",
"MUTISCUA",
"OCANA",
"PAMPLONA",
"PAMPLONITA",
"PUERTO SANTANDER",
"RAGONVALIA",
"SALAZAR",
"SAN CALIXTO",
"SAN CAYETANO",
"SANTIAGO",
"SARDINATA",
"SILOS",
"TEORAMA",
"TIBU",
"TOLEDO",
"VILLA CARO",
"VILLA DEL ROSARIO",
"ARMENIA",
"BUENAVISTA",
"CALARCA",
"CIRCASIA",
"CORDOBA",
"FILANDIA",
"GENOVA",
"LA TEBAIDA",
"MONTENEGRO",
"PIJAO",
"QUIMBAYA",
"SALENTO",
"PEREIRA",
"APIA",
"BALBOA",
"BELEN DE UMBRIA",
"DOSQUEBRADAS",
"GUATICA",
"LA CELIA",
"LA VIRGINIA",
"MARSELLA",
"MISTRATO",
"PUEBLO RICO",
"QUINCHIA",
"SANTA ROSA DE CABAL",
"SANTUARIO",
"BUCARAMANGA",
"AGUADA",
"ALBANIA",
"ARATOCA",
"BARBOSA",
"BARICHARA",
"BARRANCABERMEJA",
"BETULIA",
"BOLIVAR",
"CABRERA",
"CALIFORNIA",
"CAPITANEJO",
"CARCASI",
"CEPITA",
"CERRITO",
"CHARALA",
"CHARTA",
"CIMITARRA",
"CONCEPCION",
"CONFINES",
"CONTRATACION",
"COROMORO",
"CURITI",
"EL CARMEN DE CHUCURI",
"EL GUACAMAYO",
"EL PENON",
"ENCINO",
"FLORIAN",
"FLORIDABLANCA",
"GALAN",
"GAMBITA",
"GIRON",
"GUAPOTA",
"GUAVATA",
"GUEPSA",
"HATO",
"JESUS MARIA",
"JORDAN",
"LA BELLEZA",
"LANDAZURI",
"LEBRIJA",
"LOS SANTOS",
"MACARAVITA",
"MALAGA",
"MATANZA",
"MOGOTES",
"MOLAGAVITA",
"OCAMONTE",
"ONZAGA",
"PALMAR",
"PALMAS DEL SOCORRO",
"PARAMO",
"PIEDECUESTA",
"PINCHOTE",
"PUENTE NACIONAL",
"PUERTO PARRA",
"PUERTO WILCHES",
"RIONEGRO",
"SABANA DE TORRES",
"SAN ANDRES",
"SAN BENITO",
"SAN GIL",
"SAN JOAQUIN",
"SAN JOSE DE MIRANDA",
"SAN MIGUEL",
"SAN VICENTE DE CHUCURI",
"SANTA BARBARA",
"SANTA HELENA DEL OPON",
"SIMACOTA",
"SOCORRO",
"SUAITA",
"SUCRE",
"SURATA",
"TONA",
"VALLE DE SAN JOSE",
"VELEZ",
"VETAS",
"VILLANUEVA",
"ZAPATOCA",
"SINCELEJO",
"COLOSO",
"COROZAL",
"COVENAS",
"CHALAN",
"EL ROBLE",
"GALERAS",
"GUARANDA",
"LOS PALMITOS",
"MAJAGUAL",
"MORROA",
"OVEJAS",
"PALMITO",
"SAMPUES",
"SAN BENITO ABAD",
"SAN JUAN DE BETULIA",
"SAN MARCOS",
"SAN ONOFRE",
"SAN PEDRO",
"SINCE",
"SUCRE",
"SANTIAGO DE TOLU",
"TOLUVIEJO",
"IBAGUE",
"ALPUJARRA",
"ALVARADO",
"AMBALEMA",
"ANZOATEGUI",
"ARMERO",
"ATACO",
"CAJAMARCA",
"CARMEN DE APICALA",
"CASABIANCA",
"CHAPARRAL",
"COYAIMA",
"CUNDAY",
"DOLORES",
"ESPINAL",
"FALAN",
"FLANDES",
"FRESNO",
"GUAMO",
"HERVEO",
"HONDA",
"ICONONZO",
"LERIDA",
"LIBANO",
"MARIQUITA",
"MELGAR",
"MURILLO",
"NATAGAIMA",
"ORTEGA",
"PALOCABILDO",
"PIEDRAS",
"PLANADAS",
"PRADO",
"PURIFICACION",
"RIOBLANCO",
"RONCESVALLES",
"ROVIRA",
"SALDANA",
"SAN ANTONIO",
"SANTA ISABEL",
"VALLE DE SAN JUAN",
"VENADILLO",
"VILLAHERMOSA",
"VILLARRICA",
"CALI",
"ALCALA",
"ANDALUCIA",
"ANSERMANUEVO",
"ARGELIA",
"BOLIVAR",
"BUENAVENTURA",
"BUGA",
"BUGALAGRANDE",
"CAICEDONIA",
"CALIMA",
"CANDELARIA",
"CARTAGO",
"DAGUA",
"EL AGUILA",
"EL CAIRO",
"EL CERRITO",
"EL DOVIO",
"FLORIDA",
"GINEBRA",
"GUACARI",
"JAMUNDI",
"LA CUMBRE",
"LA UNION",
"LA VICTORIA",
"OBANDO",
"PALMIRA",
"PRADERA",
"RESTREPO",
"RIOFRIO",
"ROLDANILLO",
"SAN PEDRO",
"SEVILLA",
"TORO",
"TRUJILLO",
"TULUA",
"ULLOA",
"VERSALLES",
"VIJES",
"YOTOCO",
"YUMBO",
"ZARZAL",
"ARAUCA",
"ARAUQUITA",
"CRAVO NORTE",
"FORTUL",
"PUERTO RONDON",
"SARAVENA",
"TAME",
"YOPAL",
"AGUAZUL",
"CHAMEZA",
"HATO COROZAL",
"LA SALINA",
"MANI",
"MONTERREY",
"NUNCHIA",
"OROCUE",
"PAZ DE ARIPORO",
"PORE",
"RECETOR",
"SABANALARGA",
"SACAMA",
"SAN LUIS DE PALENQUE",
"TAMARA",
"TAURAMENA",
"TRINIDAD",
"VILLANUEVA",
"MOCOA",
"COLON",
"ORITO",
"PUERTO ASIS",
"PUERTO CAICEDO",
"PUERTO GUZMAN",
"PUERTO LEGUIZAMO",
"SIBUNDOY",
"SAN FRANCISCO",
"SAN MIGUEL",
"SANTIAGO",
"VALLE DEL GUAMUEZ",
"VILLAGARZON",
"SAN ANDRES-SAP",
"PROVIDENCIA",
"LETICIA",
"EL ENCANTO",
"LA CHORRERA",
"LA PEDRERA",
"LA VICTORIA",
"MIRITI - PARANA",
"PUERTO ALEGRIA",
"PUERTO ARICA",
"PUERTO NARINO",
"TARAPACA",
"INIRIDA",
"SAN FELIPE",
"PUERTO COLOMBIA",
"CACAHUAL",
"SAN JOSE DEL GUAVIARE",
"EL RETORNO",
"MIRAFLORES",
"MITU",
"CARURU",
"PUERTO CARRENO",
"LA PRIMAVERA",
"SANTA ROSALIA",
"CUMARIBO",
"RIOHACHA",
"ALBANIA-LAG",
"BARRANCAS",
"DIBULLA",
"DISTRACCION",
"EL MOLINO",
"FONSECA",
"HATONUEVO",
"LA JAGUA DEL PILAR",
"MAICAO",
"MANAURE",
"SAN JUAN DEL CESAR",
"URIBIA",
"URUMITA",
"VILLANUEVA-LAG"
]

